import setCurrentPage from "src/Utils/setCurrentPage";

const cards: CardDemoProps[] = [
  {
    image: "ILO/ilo1.jpg",
    imageStyle: { width: "100%" },
    title: "Sentient Business\nOperations",
    titleStyle: { marginTop: "16px" },
    text: "Leverage our AI-powered platform, backed\nby data insights to improve E2E operations\nvisibility, milestone tracking along with\nauto-heal capabilities.",
    choose: {
      label: "Select",
      onClick: () => setCurrentPage("ILO_101"),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
  {
    image: "ILO/ilo2.jpg",
    imageStyle: { width: "100%" },
    title: "Autonomous\nNetwork Operations",
    titleStyle: { marginTop: "16px" },
    text: "Enhance Network observability, including\nproactive monitoring and auto-\nremediation with our AI-powered platform,\noffering self-healing capabilities and\nproactive communication.",
    choose: {
      label: "Select",
      onClick: () => setCurrentPage("ILO_201"),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
];

const data = {
  bgImage: "ENG/bg.png",
  subtitle: "Select a demo to experience Customer Service Transformation",
  cards: cards,
  showHomeButton: true,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("INTRO_0"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
};

export default data;

// import store from "../../Reducers/store";
// import * as appActions from "src/Actions/appActions";

// const setCurrentPage = (pageIndex: string) => store.dispatch(appActions.setCurrentPage(pageIndex));

// const cards: CardDemoProps[] = [
//   {
//     label: "ILO — Business operations",
//     title: "end-to-end \n Process view",
//     text: "Enhance the observability of customer \nrequests with our AI-powered platform. \nWe provide visualization of the end-to-end \nprocess execution across multiple \ncomponents, along with proactive \ncommunication and self-healing \ncapabilities.",
//     choose: {
//       label: "CHOOSE",
//       onClick: () => setCurrentPage("ILO_101"),
//       endIcon: "arrow-right",
//     },
//     width: "400px",
//     cardCustomStyle: {
//       padding: "33px 20px 40px 20px",
//       height: "600px",
//       boxSizing: "border-box",
//     },
//   },
//   {
//     label: "ILO — Network operations",
//     title: "Autonomous \nNetwork Operations",
//     text: "Enhance network observability and auto-\nremediation with our AI-powered platform,\n offering closed-loop automation and\n proactive communication.",
//     choose: {
//       label: "CHOOSE",
//       onClick: () => setCurrentPage("ILO_201"),
//       endIcon: "arrow-right",
//     },
//     width: "400px",
//     cardCustomStyle: {
//       padding: "33px 20px 40px 20px",
//       height: "600px",
//       boxSizing: "border-box",
//     },
//   },
// ];

// const data = {
//   bgVideo: "videos/ILO/CORAL_1_1.mp4",
//   subtitle: "Select a demo to experience the next ",
//   landingTitle: "Infosys Live operations",
//   landingText:
//     "Helps deliver a better customer experience and achieve significant \nsavings by simplifying operations. Also accelerates new growth.",
//   backButton: {
//     label: "BACK",
//     onClick: () => setCurrentPage("INTRO_0"),
//     type: "transparent" as "transparent",
//     startIcon: "arrow-left",
//   },
//   cards: cards,
// };

// export default data;
